import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import ShuffledExclusiveChoiceType from '../ShuffledExclusiveChoiceType';
import ParameterFormatter from '../ParameterFormatter';

const MultipleChoice1Type = ({question}) => (
    <>
        <h4><FormattedMessage {...messages.surveys.form.label.parameterList} /></h4>
        <table className="table table-sm">
            <tbody>
                <tr>
                    <th scope="row"><FormattedMessage {...messages.surveys.form.label.min} /></th>
                    <td><ParameterFormatter value={question.min} /></td>
                </tr>
                <tr>
                    <th scope="row"><FormattedMessage {...messages.surveys.form.label.max} /></th>
                    <td><ParameterFormatter value={question.max} /></td>
                </tr>
            </tbody>
        </table>
        <h4><FormattedMessage {...messages.surveys.form.label.optionList} /></h4>
        <ShuffledExclusiveChoiceType choices={question.choices} />
    </>
);

MultipleChoice1Type.propTypes = {
    question: PropTypes.object.isRequired,
};

export default MultipleChoice1Type;
